import { makeWorkbook } from "../../utils/excel";
import { getIndicatorRegionalDelegationGroupsCounter } from "../../../../../../rest/indicator";

function statesToAoa(statesObj = {}, total = 0) {
  const entries = Object.entries(statesObj || {});
  entries.sort((a, b) => (b[1] ?? 0) - (a[1] ?? 0));
  const header = ["Estado", "Qt.", "%"];
  const rows = entries.map(([k, v]) => [
    k,
    Number(v || 0),
    total > 0 ? Number(((v || 0) * 100) / total).toFixed(1) + "%" : "0%",
  ]);
  return [header, ...rows];
}

function normalizeDelegationPayload(raw) {
  const payload = raw?.data ?? raw ?? {};
  const data = Array.isArray(payload?.data) ? payload.data : payload;

  let delegations = [];
  let summaryStates = {};
  let total = 0;

  const arr =
    data?.delegations ||
    data?.byDelegation ||
    data?.items ||
    (Array.isArray(data) ? data : null);

  if (Array.isArray(arr)) {
    delegations = arr.map((d) => {
      const name =
        d?.name ||
        d?.delegation ||
        d?.label ||
        d?.region ||
        d?.Descricao ||
        "-";
      const statesObj =
        d?.states || d?.byState || d?.counters || d?.status || d?.estados || {};
      const sum =
        typeof d?.total === "number"
          ? d.total
          : Object.values(statesObj || {}).reduce(
              (s, n) => s + Number(n || 0),
              0
            );

      return {
        name,
        total: Number(sum || 0),
        states: statesObj || {},
      };
    });

    total = delegations.reduce((s, d) => s + (Number(d.total) || 0), 0);

    const stateKeys = new Set(
      delegations.flatMap((d) => Object.keys(d.states || {}))
    );
    for (const k of stateKeys) {
      summaryStates[k] = delegations.reduce(
        (s, d) => s + Number(d.states?.[k] || 0),
        0
      );
    }
  } else {
    const maybeMap = data?.map || data?.delegations || data?.byDelegation || {};
    const keys = Object.keys(maybeMap || {});
    if (keys.length) {
      delegations = keys.map((k) => {
        const v = maybeMap[k];
        const statesObj =
          v?.states || v?.byState || v?.counters || v?.status || v || {};
        const sum =
          typeof v?.total === "number"
            ? v.total
            : Object.values(statesObj).reduce((s, n) => s + Number(n || 0), 0);
        return { name: k, total: Number(sum || 0), states: statesObj };
      });

      total = delegations.reduce((s, d) => s + (Number(d.total) || 0), 0);
      const stateKeys = new Set(
        delegations.flatMap((d) => Object.keys(d.states || {}))
      );
      for (const k of stateKeys) {
        summaryStates[k] = delegations.reduce(
          (s, d) => s + Number(d.states?.[k] || 0),
          0
        );
      }
    } else {
      delegations = [];
      total = Number(data?.total || 0);
      summaryStates =
        data?.summaryStates || data?.states || data?.byState || {};
    }
  }

  return {
    total,
    delegations,
    summaryStates,
    delegationsCount: delegations.length,
  };
}

export async function buildWorkbookDelegation() {
  const resp = await getIndicatorRegionalDelegationGroupsCounter();
  const norm = normalizeDelegationPayload(resp);

  const resumo = [
    ["Indicador", "Valor"],
    ["Total", Number(norm.total || 0)],
    ["Delegações", Number(norm.delegationsCount || 0)],
    [],
    ["Distribuição global por estado"],
  ];
  const distAoa = statesToAoa(norm.summaryStates, norm.total);
  const resumoAoa = [...resumo, ...distAoa];

  const stateKeys = Array.from(
    new Set(norm.delegations.flatMap((d) => Object.keys(d.states || {})))
  );

  const header = ["Delegação", "Total", ...stateKeys];
  const rows = norm.delegations.map((d) => [
    d.name,
    Number(d.total || 0),
    ...stateKeys.map((k) => Number(d.states?.[k] || 0)),
  ]);

  const porDelegacaoAoa = [header, ...rows];

  const wb = makeWorkbook([
    { name: "Resumo", aoa: resumoAoa },
    { name: "PorDelegacao", aoa: porDelegacaoAoa },
  ]);

  return wb;
}
